import type { AxiosRequestConfig } from 'axios';
import z from 'zod';
import { api } from '../../axios.instance';

const _DeleteResidentNoteByIdRequestDtoSchema = z.object({
  id: z.number(),
  noteId: z.number(),
});

export type DeleteResidentNoteByIdRequestDto = z.infer<
  typeof _DeleteResidentNoteByIdRequestDtoSchema
>;

export const deleteResidentNote = async (
  params: DeleteResidentNoteByIdRequestDto,
  config?: AxiosRequestConfig<DeleteResidentNoteByIdRequestDto>
) => {
  const { id, noteId } = params;

  return await api.delete(`residents/${id}/notes/${noteId}`, config);
};
